<template>
    <div id="caseMgmtBox">      
        <div class="searchWrap">
            <div class="row">
    
                <div class="itemWrap" v-if="btnDivVisible">
                    <span >區處分行</span>
                    <DivSelection v-model="selectedDiv" :noDivision="true" :filterDivisionCode="filterDivisionCode"  @branch-selected="handleDivChange" :style="{ width: '150px', marginLeft: '10px' }" />
                </div> 
                <div class="itemWrap" v-if="btnUserVisible">
                    <span >承辦人</span>
                    <el-select v-model="listQuery.UserID" placeholder="請選擇承辦人" clearable style="margin-left: 10px;">                        
                        <el-option label="全部" value="全部"></el-option>
                        <el-option v-for="item in branchStaffList" :key="item.ID" :label="item.UserName" :value="item.UserID"></el-option>                        
                    </el-select>
                </div>         
                <div class="itemWrap">
                    <span >資料來源</span>
                    <el-select v-model="listQuery.Source" placeholder="請選擇資料來源" clearable style="margin-left: 10px;" >                        
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="總行派案" value="總行派案"></el-option>
                        <el-option label="續約重訂" value="續約重訂"></el-option>                        
                        <el-option label="自行開發" value="自行開發"></el-option>                        
                    </el-select>
                </div>
                <div class="itemWrap">
                    <span >訪視進度</span>                    
                    <el-select v-model="listQuery.Case_Prog" placeholder="請選擇案件訪視進度" clearable style="margin-left: 10px;">                        
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="已訪視完成" value="已訪視完成"></el-option>
                        <el-option label="尚未訪視完成" value="尚未訪視完成"></el-option>                                                
                    </el-select>
                </div>                                             
                <div class="itemWrap ">
                    <span >案件狀態</span>                    
                    <el-select v-model="listQuery.Case_Status" placeholder="請選擇案件狀態" clearable style="margin-left: 10px;">                        
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="1.待分派" value="待分派"></el-option>
                        <el-option label="2.待安排訪視" value="待安排訪視"></el-option>                        
                        <el-option label="3.已安排訪視" value="已安排訪視"></el-option>                        
                        <el-option label="4.客戶拒絕" value="客戶拒絕"></el-option>
                        <el-option label="5.其他" value="其他"></el-option>
                        <el-option label="6.已訪視" value="已訪視"></el-option>
                        <el-option label="7.撤件" value="撤件"></el-option>
                        <el-option label="8.續行申貸" value="續行申貸"></el-option>                        
                        <el-option label="9.核准" value="核准"></el-option>
                    </el-select>
                </div>                   
            </div>
            <div class="row">            
                <div class="itemWrap">
                    <span >專案名稱</span>
                    <el-select v-model="listQuery.Project_Name" placeholder="請選擇專案名稱" clearable style="margin-left: 10px;" @click="clickLoadProjectName">
                        <el-option label="全部" value="全部"></el-option>
                        <el-option v-for="item in projectNameList" :key="item" :label="item" :value="item"></el-option>                        
                    </el-select>
                </div>                    
                <div class="itemWrap">
                    <span >到期日/限辦日期</span>
                    <el-date-picker width="50%"
                    v-model="dateRange"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="閞始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
                    </el-date-picker>
                </div>              
                
                <div class="itemWrap">
                    <el-input v-model="keyword" placeholder="公司名稱 / 統一編號 " style="margin-right:15px;width:100%;" clearable></el-input>                    
                    <el-button style="margin-left: 20px;" type="primary" icon="el-icon-search" @click="doSearch">查詢</el-button>
                </div>
                <div class="itemWrap export-right" >
                    <el-button type="danger" icon="el-icon-tickets" @click="exportExcel" >匯出</el-button>
                </div>
                
            </div>

        </div>        
        <div class="content" >
            <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="tableData" @selection-change="handleSelectionChange">                            
                <el-table-column type="selection" width="88" label-class-name="export-selection-column"></el-table-column>
                <el-table-column label="案件編號"  prop="caseid" min-width="15%">
                    <template slot-scope="scope">                           
                        <a class="case-link" @click="btnOpDetail(scope.row)" style="color: #409EFF; cursor: pointer; text-decoration: none;">{{scope.row.CaseNo}}</a>                        
                    </template>                    
                </el-table-column>                              
                <el-table-column label="統一編號"  prop="UniComNm" min-width="15%">
                    <template slot-scope="scope"> 
                        <el-tooltip content="將開啟新頁" placement="top">                                 
                        <a class="goDetailPage" @click="doShowCompanyDetail(scope.row)">{{ scope.row.UniComNm }}</a>
                        </el-tooltip>
                    </template>                      
                </el-table-column>                
                <el-table-column label="公司名稱" prop="ComName"  min-width="15%">      
                    <template slot-scope="scope">                       
                        <el-tooltip content="將開啟新頁" placement="top">
                        <a class="goDetailPage" @click="doshowDetail(scope.row)">{{ scope.row.ComName }}</a>
                        </el-tooltip>
                    </template>                              
                </el-table-column>                
                <el-table-column label="資料來源" prop="Source"  min-width="15%">                
                </el-table-column>                

                <el-table-column label="預計訪視時間" prop="ExpectVisitDt"  min-width="15%">
                    <template slot-scope="scope">
                        {{ formatExpectVisitDisplay(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column label="案件狀態" prop="CaseStatus"  min-width="15%">                
                </el-table-column>  
                <el-table-column label="覆核狀態" prop="ApprovedStatus"  min-width="15%">                
                </el-table-column>                     
                <el-table-column label="承辦人" prop="AssigneeUserName"  min-width="15%">                
                </el-table-column>       
                <el-table-column label="專案名稱"  prop="ProjectName" min-width="15%"  >
                </el-table-column>                         
                <el-table-column label="到期日/限辦日期"  prop="CloseDt" min-width="15%"  >
                </el-table-column>                                                                                           -->
            </el-table>                
        </div>
        <div class="pageBox">
            <Pagination
                @currentChange="pageChange"
                :pageSize="this.listQuery.Page_Size"
                :propsCurrentPage="this.listQuery.Page_Num"
                :totalLists="totalLists">
            </Pagination>
        </div>  
        <el-dialog title="案件明細" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="closeDialog" width="70%" center>
            <div class="dialogBox">
                <div class="details-container">
                    <div class="detail-row">
                        <div class="detail-label">案件編號</div>
                        <div class="detail-content">{{ this.details && this.details.CaseNo }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">到期日/限辦日期</div>
                        <div class="detail-content">{{ this.details && this.details.DueDt }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">統一編號</div>
                        <div class="detail-content">{{ this.details && this.details.UniComNm }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">公司名稱</div>
                        <div class="detail-content">{{ this.details && this.details.ComName }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">資料來源</div>
                        <div class="detail-content">{{ this.details && this.details.Source }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">專案名稱</div>
                        <div class="detail-content">{{ this.details && this.details.ProjectName }}</div>
                    </div>
                    <div class="detail-row col-span-2" >
                        <div class="detail-label">案件狀態</div>
                        <div class="detail-content" >
                            <el-select :disabled="!editDetail" v-model="details.CaseStatus" placeholder="請選擇案件狀態" @change="checkReason" style="width:35%">
                                <el-option v-for="(options, index) in nextSelectList" :key="index" :value="options"></el-option>
                            </el-select>
                            <el-select :disabled="!showReason || !editDetail" v-model="details.CaseReason" placeholder="請選擇原因" style="margin-left:10px; width: 35%;" @change="checkOther">
                                <el-option v-for="(options, index) in selectedReason" :key="index" :label="options" :value="options"></el-option>
                            </el-select>
                            <el-input type="input"  :disabled="!editDetail || details.CaseReason !== '其他'" v-model="details.CaseReasonDescription" placeholder="請說明原因..." style="margin-left:10px; width: 100%;"></el-input>
                        </div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">預計訪視時間</div>
                        <el-date-picker :disabled="!editDetail" v-model="details.ExpectVisitDt" type="date" size="small" value-format="yyyy-MM-dd" style="width: 25%;margin-right:1rem;"></el-date-picker>
                        <el-radio :disabled="!editDetail" v-model="details.vTime" label="10">上午</el-radio>
                        <el-radio :disabled="!editDetail" v-model="details.vTime" label="14">下午</el-radio>                            
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">區處</div>
                        <div class="detail-content">{{ this.details && this.details.DivisionName }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">分行名稱</div>
                        <div class="detail-content">{{ this.details && this.details.DeptName }}</div>
                    </div>

                    <div class="detail-row" v-if="reFieldVisible">
                        <div class="detail-label">ELN編號</div>
                        <div class="detail-content">{{ this.details && this.details.ELNNo }}</div>
                    </div>                    
                    <div class="detail-row" v-if="reFieldVisible">
                        <div class="detail-label">餘額</div>
                        <div class="detail-content">{{ this.details && this.details.CurrentAmount }}</div>
                    </div>                                                            

                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">信評等級</div>
                        <div class="detail-content">{{ this.details && this.details.CreditRating }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">資本額</div>
                        <div class="detail-content">{{ this.details && this.details.CapitalAmount }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">員工人數</div>
                        <div class="detail-content">{{ this.details && this.details.EmployeeCount }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">台幣放款戶(Y/N)</div>
                        <div class="detail-content">{{ this.details && this.details.TwdLoanAccountYN }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">有外幣存款(Y/N)</div>
                        <div class="detail-content">{{ this.details && this.details.FxDepositAccountYN }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">衍生性金融商品(Y/N)</div>
                        <div class="detail-content">{{ this.details && this.details.DerivativeProductYN }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">近一年貢獻度(千元)</div>
                        <div class="detail-content">{{ this.details && this.details.LastYearContribution }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">外匯存款AUM(千元)</div>
                        <div class="detail-content">{{ this.details && this.details.FxDepositAUM }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">AUM</div>
                        <div class="detail-content">{{ this.details && this.details.TotalAUM }}</div>
                    </div>
                    

                    <div class="detail-row">
                        <div class="detail-label">覆核主管</div>
                        <div class="detail-content">{{ this.details && this.details.ApproveUserName }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">承辦人</div>
                        <div class="detail-content">{{ this.details && this.details.AssigneeUserName }}</div>
                        <div class="detail-content" v-if="assignBtnVisible">
                            <!-- 指派承辦人 -->
                            <el-select v-model="seletedStaff" placeholder="變更承辦人" clearable style="width: 200px;" @change="changeStaff" >
                                <el-option
                                    v-for="item in branchStaffList"
                                    :key="item.ID"
                                    :label="`${item.UserName} (${item.RoleName})`"
                                    :value="item.ID">
                                </el-option>
                            </el-select>
                        </div>                        
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">建立時間</div>
                        <div class="detail-content">{{ details && details.CreateDt }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">備註</div>
                        <!-- <div class="detail-content">{{ details && details.Memo }}</div> -->
                        <el-input :disabled="!editDetail"  v-model="details.Memo" style="width: 100%;" :maxlength="100" show-word-limit></el-input>                            
                    </div>                    
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">備註1</div>
                        <div class="detail-content" > {{ details && details.Memo1 }}
                            <!-- <el-input :disabled="!editDetail"  v-model="details.Memo1" style="width: 100%;"></el-input>                             -->
                        </div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">備註2</div>
                        <div class="detail-content" > {{ details && details.Memo2 }}
                            <!-- <el-input :disabled="!editDetail"  v-model="details.Memo2" style="width: 100%;"></el-input>                             -->
                        </div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">備註3</div>
                        <div class="detail-content" > {{ details && details.Memo3 }}
                            <!-- <el-input :disabled="!editDetail"  v-model="details.Memo3" style="width: 100%;"></el-input>                             -->
                        </div>
                    </div>
                </div>  
            </div>
            <span slot="footer" class="dialog-footer">                
                <el-button type="primary" @click="showCaseHistory"><font-awesome-icon icon="history" style="margin-right:5px;" />查看案件歷程</el-button>                
                <el-button type="primary" v-if="editBtnVisible && !submitOrNot "  @click="btnEditDetail()"><font-awesome-icon icon="edit" style="margin-right:5px;" />編輯</el-button>
                <el-button type="success" v-if="saveBtnVisible" @click="btnSaveDetail()"><font-awesome-icon icon="plus" style="margin-right:5px;" />{{ btnSaveTitle }}</el-button>
                <el-button type="primary" v-if="assignBtnVisible" @click="assignBtn()"><font-awesome-icon icon="times" style="margin-right:5px;" />{{ assignBtnTitle }}</el-button>
                <el-button type="primary"  v-if="btnApprove" @click="apprBtn()" ><font-awesome-icon icon="edit"  style="margin-right:5px;" />覆核</el-button>
                <el-button type="success"  v-if="btnApprove" @click="rejectBtn()" ><font-awesome-icon icon="edit"  style="margin-right:5px;" />退回</el-button>
                <el-button type="danger" @click="closeDialog()"><font-awesome-icon icon="times" style="margin-right:5px;" />關閉</el-button>
            </span>
        </el-dialog>       
        
        <!-- 案件歷程 drawer -->
        <el-drawer
            :visible.sync="historyDrawerVisible"
            direction="rtl"
            size="40%">
            <template slot="title">
                <span style="font-size: 20px; font-weight: bold;">案件歷程</span>
            </template>
            <div style="padding: 20px;">
                <el-table :data="caseHistoryData" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" border stripe style="width: 100%">
                    <el-table-column prop="TriggerDt" label="建立時間" min-width="150" :formatter="formatDateTimeToMinute"></el-table-column>
                    <el-table-column prop="ActionType" label="類型" min-width="120"></el-table-column>
                    <el-table-column prop="TriggerUserName" label="異動人" min-width="100"></el-table-column>
                    <el-table-column prop="AssigneeUserName" label="承辦人" min-width="100"></el-table-column>
                    <el-table-column prop="Memo" label="備註" min-width="150"></el-table-column>
                    
                </el-table>
                <div style="margin-top: 20px; text-align: right;">
                    <el-button type="primary" @click="historyDrawerVisible = false">關閉</el-button>
                </div>
            </div>
        </el-drawer>         
</div>
</template>

<script>
import Pagination from '../../components/Pagination.vue';
import DivSelection from '../../components/DivSelection.vue';
import { notify, handleError } from '@/utils/notify.js';
import ExcelJS from 'exceljs';


export default {
  components: {
    Pagination,
    DivSelection
  },
      data() {
        return {

            assignBtnTitle: "指派", // 指派按鈕文字(只有案件狀態為待分派時是”指派”，其他狀態時是”改派”)
            btnApprove: false, // 覆核按鈕顯示控制
            btnDivVisible: false, // 區處分行選擇顯示控制
            btnUserVisible: false, // 承辦人選擇顯示控制
            submitOrNot: false, // 若已申請覆核, 則不可再編輯
            btnSaveTitle: "儲存",

            hqFieldVisible: false, // 總行欄位顯示控制
            reFieldVisible: false, // 續約欄位顯示控制
            assignBtnVisible: false, // 指派按鈕顯示控制
            editBtnVisible: false, // 編輯按鈕顯示控制
            saveBtnVisible: false, // 儲存按鈕顯示控制
            keyword: "",
            dialogVisible: false,
            caseStaffList: [], // 承辦人員, 提供下拉, 由案件承辦人員清單取得(Distinct)
            status_transion: [
                {'待安排訪視': ['待安排訪視','客戶拒絕', '其他', '已安排訪視']},
                {'已安排訪視': ['已安排訪視','已訪視']},
                {'已訪視': ['已訪視','撤件', '續行申貸', '已安排訪視']}                
            ],
            nextSelectList: [],
            showReason: false,
            ReasonList: [
                {"客戶拒絕": ['對產品/服務不感興趣', '要求特定時間再聯繫', '暫無資金需求','已有往來行庫', '其他']},
                {"其他": ['重覆名單', '聯絡方式錯誤','聯絡不上','停歇業', '其他']},
                {"撤件": ['訪談後無意願', '要求特定時間再聯繫', '其他']}
            ],
            selectedReason: [],

            tableData: [],
            btnName: "編輯",

            dateRange: [],
            filterDivisionCode:'',

            pickerOptions: {
                shortcuts: [{
                    text: '最近一週',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },

            projectNameList: [],
            branchStaffList: [],
            seletedStaff: '',
            selectedDiv: [],

            totalLists: 0,
            listQuery: {   
                Page_Size:10,
                Page_Num:1,
                Case_Prog: '尚未訪視完成',
            },   

            
            selectedRow: {},
            details: {},
            editDetail: false,
            // 使用者在表格中勾選的案件
            selectedCases: [],
            // 用 map 儲存跨頁選取 (key = ID, value = row)
            selectedCaseMap: {},
            // 標記是否在恢復選取狀態（避免 handleSelectionChange 誤刪）
            isRestoringSelection: false,
            
            // 案件歷程相關
            historyDrawerVisible: false,
            caseHistoryData: [],
            selectedRow: null
        }        

        
    },
    methods: {


        formatExpectVisitDisplay(row) {
            if (!row || !row.ExpectVisitDt) return '';

            const dateText = String(row.ExpectVisitDt).split('T')[0];
            const rawStartTime = row.ExpectVisitStartTime || row.Expect_Visit_Start_Time || '';
            const hour = parseInt(String(rawStartTime).split(':')[0], 10);
            const period = (!Number.isNaN(hour) && hour >= 12) ? '下午' : '上午';

            return `${dateText} ${period}`;
        },

        formatDateTimeToMinute(row, column, cellValue) {
            const value = cellValue || (row && row[column && column.property]);
            if (!value) return '';

            // 支援 "2026-01-01T18:56:43" 或 "2026-01-01 18:56:43"
            const text = String(value).replace('T', ' ').trim();
            if (text.length >= 16) {
                return text.slice(0, 16);
            }
            return text;
        },

        // 當使用者勾選/取消勾選表格列時呼叫
        handleSelectionChange(selectedRows) {
            // 若正在恢復選取狀態，跳過此次處理
            if (this.isRestoringSelection) {
                return;
            }
            
            // 當前頁面被選取的 row 陣列
            selectedRows = selectedRows || [];

            // 將當前頁被選的加入 map（使用字串 key 確保一致）
            selectedRows.forEach(r => {
                if (r && r.ID !== undefined && r.ID !== null) {
                    this.selectedCaseMap[String(r.ID)] = r;
                }
            });

            // 對當前頁未被選的 row，從 map 中移除（只影響當前頁）
            if (this.tableData && this.tableData.length) {
                this.tableData.forEach(row => {
                    const key = String(row.ID);
                    const stillSelected = selectedRows.some(r => String(r.ID) === key);
                    if (!stillSelected && this.selectedCaseMap[key]) {
                        // 只有當該 row 屬於當前頁且未再被選取時才刪除
                        delete this.selectedCaseMap[key];
                    }
                });
            }

            // 同步方便用的陣列表示（保持 map 的最新 row 物件）
            this.selectedCases = Object.values(this.selectedCaseMap);
            console.log('目前跨頁被選取的案件數:', this.selectedCases.length);
        },

        // 取得目前被選取的案件（優先回傳跨頁累積的 selectedCaseMap）
        getSelectedCases() {
            const mapVals = Object.values(this.selectedCaseMap || {});
            if (mapVals && mapVals.length) return mapVals;
            if (this.selectedCases && this.selectedCases.length) return this.selectedCases;
            return (this.$refs.multipleTable && this.$refs.multipleTable.selection) || [];
        },


        // 主管覆核
        apprBtn(){

            // this.selectedRow 來決定要覆核的案件
            console.log("覆核案件", this.selectedRow);
            const qry = {
                "ID": this.selectedRow.ID,
                "Approved_Status": "approved"
            }
            this.$api.apicase.case_approve(qry).then(response => {
                console.log("覆核結果",response);
                notify({
                    title: "成功",
                    message: "案件覆核成功",
                    type: "success"
                }); 
                this.dialogVisible = false;
                this.getList();               
            }).catch(error => {
                console.error("案件覆核失敗", error);
                notify({
                    title: "錯誤",
                    message: "案件覆核失敗，請稍後再試",
                    type: "error"
                });                
            });

        },

        // 主管退回
        rejectBtn(){
            // this.selectedRow 來決定要覆核的案件
            console.log("覆核案件", this.selectedRow);
            const qry = {
                "ID": this.selectedRow.ID,
                "Approved_Status": "rejected"
            }
            this.$api.apicase.case_approve(qry).then(response => {
                console.log("覆核結果",response);
                notify({
                    title: "成功",
                    message: "案件覆核拒絕，已退回承辦人",
                    type: "success"
                }); 
                this.dialogVisible = false;
                this.getList();               
            }).catch(error => {
                console.error("案件覆核失敗", error);
                notify({
                    title: "錯誤",
                    message: "案件覆核失敗，請稍後再試",
                    type: "error"
                });                
            });            

        },

        handleDivChange(val) {
            console.log("handleDivChange", val);
            // console.log("handleDivChange selectedDiv", this.selectedDiv);
            this.listQuery.DivisionCode = val.DivisionCode;
            this.listQuery.DeptID = val.DeptID;
        },        

        // 取得分行承辦人清單
        getBranchStaff() {
            const deptID = window.localStorage.getItem('deptID');
            const qry = {
                "DeptID": deptID,
                "isSys": true
            };
            console.log("獲取分行承辦人清單參數", qry);
            this.$api.apidivison.contact_list_search(qry).then(response => {
                console.log("分行承辦人清單",response);
                this.branchStaffList = response.data.filter(item => item.RoleName == "UC" || item.RoleName == "UAO"); 
            }).catch(error => {
                console.error("獲取分行承辦人清單失敗", error);
                notify({
                    title: "錯誤",
                    message: "獲取分行承辦人清單失敗，請稍後再試",
                    type: "error"
                });                
            });
        },      
        // 主管指派承辦人
        assignBtn() {
            console.log("選擇的承辦人ID:", this.seletedStaff);
            if(!this.seletedStaff) {
                notify({
                    title: "警告",
                    message: "請選擇承辦人",
                    type: "warning"
                }); 
                return;
            }
            // 從staffList中找到對應的使用者ID
            const staff = this.branchStaffList.find(item => item.ID === this.seletedStaff);
            console.log("選擇的承辦人資料:", staff);     
            const qry = {
                "ID": this.selectedRow.ID,
                "Assignee_User_ID": staff.UserID,
                "Assignee_User_Name": staff.UserName,                
            }                  
            console.log("目前文字參數", this.assignBtnTitle);
            // 依據按鈕文字來決定是否為第一次指派或改派，並設定 Is_Reassign 參數
            if(this.assignBtnTitle === "指派") {
                qry.Is_Reassign = false; // 第一次.. 要設成false,
            }
            if(this.assignBtnTitle === "改派") {
                qry.Is_Reassign = true; // 若是改派, 代表已經指派過了, 這次是改派, 要設成true
            }            
            //console.log("案件指派參數", qry);
            this.$api.apicase.case_assign(qry).then(response => {
                console.log("指派結果",response);
                notify({
                    title: "成功",
                    message: "案件指派成功",
                    type: "success"
                }); 
                this.dialogVisible = false;
                this.getList();               
            }).catch(error => {
                console.error("案件指派失敗", error);
                notify({
                    title: "錯誤",
                    message: "案件指派失敗，請稍後再試",
                    type: "error"
                });                
            });      

        },          

        changeStaff(value) {
            // console.log("選擇的承辦人:", value);
            // console.log("選擇的承辦人ID:", this.seletedStaff);
            // 從staffList中找到對應的使用者ID
            const staff = this.branchStaffList.find(item => item.ID === this.seletedStaff);
            console.log("選擇的承辦人資料:", staff);
            
            this.details.AssigneeUserName = staff.UserName; // 更新 details 中的承辦人欄位

        },         

        async exportExcel() {
            // 檢查是否有資料
            if ((!this.tableData || this.tableData.length === 0) && (!this.selectedCases || this.selectedCases.length === 0)) {
                notify({
                    title: "錯誤",
                    message: "目前無資料可匯出",
                    type: "error"
                });
                return;
            }

            try {
                // 只匯出使用者明確勾選的項目，若無選取則提示
                const rows = this.getSelectedCases() || [];
                if (!rows || rows.length === 0) {
                    notify({ title: '警告', message: '請先勾選要匯出的案件', type: 'warning' });
                    return;
                }
                console.log('匯出以下案件:', rows);

                // 將資料轉換為適合匯出的格式（中文欄位標題）
                const exportData = rows.map(r => ({
                    '案件編號': r.CaseNo || '',
                    '案件狀態': r.CaseStatus || '',
                    '案件原因': r.CaseReason || '',
                    '原因說明': r.CaseReasonDescription || '',
                    '覆核狀態': r.ApprovedStatus || '',
                    '區處': r.DivisionName || '',
                    '分行名稱': r.DeptName || '',
                    '承辦人': r.AssigneeUserName || '',
                    '預計訪視時間': r.ExpectVisitDt || '',
                    '統一編號': r.UniComNm || '',
                    '公司名稱': r.ComName || '',
                    '資料來源': r.Source || '',
                    '專案名稱': r.ProjectName || '',
                    '到期日/限辦日期': r.CloseDt || '',
                    '備註': r.Memo || '',
                    '建立時間': r.CreateDt || ''
                }));

                const exportUniComNms = exportData.slice(0, 10).map(d => d['統一編號']).join(', ');

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('案件');

                const headers = [
                    '案件編號',
                    '案件狀態',
                    '案件原因',
                    '原因說明',
                    '覆核狀態',
                    '區處',
                    '分行名稱',
                    '承辦人',
                    '預計訪視時間',
                    '統一編號',
                    '公司名稱',
                    '資料來源',
                    '專案名稱',
                    '到期日/限辦日期',
                    '備註',
                    '建立時間'
                ];

                worksheet.addRow(headers);
                exportData.forEach(item => {
                    worksheet.addRow(headers.map(header => item[header]));
                });

                const now = new Date();
                const ts = `${now.getFullYear()}${String(now.getMonth()+1).padStart(2,'0')}${String(now.getDate()).padStart(2,'0')}_${String(now.getHours()).padStart(2,'0')}${String(now.getMinutes()).padStart(2,'0')}`;
                const filename = `案件列表_${ts}.xlsx`;

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);


                // 要做一個稽核記錄.. 呼叫後端 API 紀錄匯出行為                
                const setAudit = {
                    "menu_path": ["客戶名單管理", "案件管理"],
                    "action_type": "export",
                    "action_name": "匯出",
                    "details": {
                        "UniComNms": exportUniComNms,                        
                        "exported_count": exportData.length
                    }
                }
                const resp = this.$api.apimgrs.setAuditLog(setAudit);                   

                notify({ title: '成功', message: `已下載 ${filename}`, type: 'success' });
            } catch (err) {
                console.error('匯出 Excel 發生錯誤', err);
                notify({ title: '錯誤', message: '匯出失敗，請稍後再試', type: 'error' });
            }
        },

        async pageChange(val) {
            this.listQuery.Page_Num = val;
            await this.getList();
        },

        doshowDetail(row) {
            console.log(row);
            this.$queryRecord(this, row.ComName, 'company');  // 記錄點擊公司名            
            const url = `/ctmMapCom?unicomnm=${row.UniComNm}`;
            window.open(url, '_blank');

        },        

        // 串到公司詳細資訊頁... http://localhost:1200/companyDetail?comid=90699843&comname=台泥東立綠能股份有限公司
        async doShowCompanyDetail(data) {
            console.log(data);
            const comid = data.UniComNm;
            const comname = data.ComName;

            this.$queryRecord(this, comname, 'company');  // 記錄點擊公司名
            // 開啟新視窗, 顯示公司詳細資訊
            const url = `/companyDetail?comid=${comid}&comname=${comname}`;
            window.open(url, '_blank');		
            
        },     

        closeDialog() {
            this.editDetail = false;
            this.saveBtnVisible = false;
            // 根据权限和案件状态恢复编辑按钮
            // 若案件已申请覆核(submitOrNot=true)或没有编辑权限，则隐藏编辑按钮
            const userHasEditPermission = this.$store.getters.userMenu
                ?.find(item => item.Name === "案件管理")?.Action
                ?.some(item => item.Action === "修改案件") || false;
            this.editBtnVisible = userHasEditPermission && !this.submitOrNot;
            this.dialogVisible = false;            
        },

        doSearch() {
            this.listQuery.Page_Num = 1; // 重置頁碼到第一頁
            if( this.keyword && this.keyword.trim() !== '' )
                this.$queryRecord(this, this.keyword, 'keyword');  // 記錄搜尋關鍵字            
            this.getList();
            // 在這裡添加搜尋邏輯，例如發送請求到後端 API
        },

        getList() {

            let qry = {
                "Page_Size": this.listQuery.Page_Size,
                "Page_Num": this.listQuery.Page_Num,
            }
            console.log("原始查詢參數", this.listQuery);

            // if (this.listQuery.DeptID && this.listQuery.DeptID.length > 0) {
            //     qry.Division_Code = this.listQuery.DeptID[0];
            // }
            if( this.selectedDiv && this.selectedDiv.length > 0 ){
                qry.DeptID = this.selectedDiv[1];
                qry.Division_Code = this.selectedDiv[0];
            }

            if( this.keyword && this.keyword.trim() !== '' ){
                qry.Keyword = this.keyword.trim();
            }
            
            if( this.listQuery.Source && this.listQuery.Source !== '全部' ){
                qry.Source = this.listQuery.Source;
            }
            if( this.listQuery.Project_Name && this.listQuery.Project_Name.trim() !== '全部' ){
                qry.Project_Name = this.listQuery.Project_Name;
            }
            if( this.listQuery.Case_Status && this.listQuery.Case_Status !== '全部' ){
                qry.Case_Status = [this.listQuery.Case_Status];                
            }

            if(this.dateRange && this.dateRange.length === 2 ){
                this.listQuery.Due_START = this.dateRange[0].toISOString().split('T')[0];
                this.listQuery.Due_END = this.dateRange[1].toISOString().split('T')[0];
            }

            // 只取區處
            // if( this.listQuery.DeptID && this.listQuery.DeptID.length > 0 ){
            //     qry.Division_Code = this.listQuery.DeptID[0];
            // }
            
            // 承辦人
            if( this.listQuery.UserID && this.listQuery.UserID.length > 0 && this.listQuery.UserID !== '全部' ){
                qry.Assignee_User_ID = this.listQuery.UserID;
            }

            // 訪視進度..  已訪視完成的定義為走到最後狀態，且主管已覆核的案件
            if( this.listQuery.Case_Prog && this.listQuery.Case_Prog == '已訪視完成' && this.listQuery.Case_Status !== '全部' )
                qry.IsCompleted = "Y";
            if( this.listQuery.Case_Prog && this.listQuery.Case_Prog == '尚未訪視完成' && this.listQuery.Case_Status !== '全部' )
                qry.IsCompleted = "N";


            console.log("整理後的查詢參數", qry);

            this.$api.apicase.case_list(qry).then(response => {
                console.log("獲取列表回應",response);
                this.tableData = response.data;
                this.totalLists = response.total;   
                // 預載承辦人清單以供篩選使用
                const distinctStaff = [];
                console.log("準備預載承辦人清單 from tableData", this.tableData);
                this.tableData.forEach(item => {
                    if( item.AssigneeUserID && !distinctStaff[item.AssigneeUserID] ){
                        distinctStaff[item.AssigneeUserID] = item.AssigneeUserName;
                    }
                    // 針對 ApprovedStatus 做處理,  若是approved='已覆核'
                    // 若是 'rejected' 則顯示 '退回承辦'
                    // 若是 'pending' 則顯示 '待覆核'
                    if( item.ApprovedStatus == 'approved' ){
                        item.ApprovedStatus = '已覆核';
                    } else if( item.ApprovedStatus == 'rejected' ){
                        item.ApprovedStatus = '退回承辦';
                    } else if( item.ApprovedStatus == 'pending' ){
                        item.ApprovedStatus = '待覆核';
                    }

                    switch(item.CaseStatus) {
                        case '待分派':
                            item.CaseStatus = '1.待分派';
                            break;
                        case '待安排訪視':
                            item.CaseStatus = '2.待安排訪視';
                            break;
                        case '已安排訪視':
                            item.CaseStatus = '3.已安排訪視';
                            break;
                        case '客戶拒絕':
                            item.CaseStatus = '4.客戶拒絕';
                            break;
                        case '其他':
                            item.CaseStatus = '5.其他';
                            break;
                        case '已訪視':
                            item.CaseStatus = '6.已訪視';
                            break;
                        case '撤件':
                            item.CaseStatus = '7.撤件';
                            break;
                        case '續行申貸':
                            item.CaseStatus = '8.續行申貸';
                            break;
                        case '核准':
                            item.CaseStatus = '9.核准';
                            break;                                                        
                    }


                });
                // this.caseStaffList = Object.keys(distinctStaff).map(key => {
                //     return { UserID: key, UserName: distinctStaff[key] };
                // });
                // console.log("預載承辦人清單", this.caseStaffList);                             
                // 恢復跨頁選取狀態：若 selectedCaseMap 包含當前頁的 row，則標為已選
                this.isRestoringSelection = true;
                this.$nextTick(() => {
                    // 延遲以確保表格 DOM 完全初始化後再還原選取
                    setTimeout(() => {
                        if (this.$refs.multipleTable && this.tableData && this.tableData.length) {
                            this.tableData.forEach(row => {
                                const key = String(row.ID);
                                if (this.selectedCaseMap && this.selectedCaseMap[key]) {
                                    try {
                                        // 更新 map 中儲存的 row 物件為目前頁面的 row
                                        this.selectedCaseMap[key] = row;
                                        this.$refs.multipleTable.toggleRowSelection(row, true);
                                    } catch (e) {
                                        // ignore
                                    }
                                }
                            });
                            // 更新陣列表示
                            this.selectedCases = Object.values(this.selectedCaseMap);
                        }
                        // 恢復完成，開放 handleSelectionChange
                        this.isRestoringSelection = false;
                    }, 10);
                });
            }).catch(error => {
                notify({
                    title: "錯誤",
                    message: "獲取列表失敗，請稍後再試",
                    type: "error"
                });                
            });
        },

        checkOther() {            
            // 如果是客戶拒絕, 原因下拉選單中有"其他", 再下面開出一個輸入框讓使用者填寫
            if( this.details && this.details.CaseReason === '其他' ){
                
            }
        },
        
        

        checkReason() {
            // 判斷是否需要填寫理由, 需要找ReasonList中, 若有符合的選項, 則顯示理由填寫下拉原因.
            this.showReason = false;
            this.selectedReason = [];
            
            for( let i=0; i<this.ReasonList.length; i++ ){
                const key = Object.keys(this.ReasonList[i])[0];
                if( this.details && this.details.CaseStatus && key === this.details.CaseStatus ){
                    this.showReason = true;
                    this.selectedReason = this.ReasonList[i][key];
                    break;
                }
            }

            

            if( this.details && this.details.CaseStatus == '客戶拒絕' || this.details && this.details.CaseStatus == '撤件' || this.details && this.details.CaseStatus == '續行申貸' || this.details && this.details.CaseStatus == '其他' ){
                this.btnSaveTitle = "申請覆核並儲存";
            } else {
                this.btnSaveTitle = "儲存";
            }

            if( !this.showReason && this.details && this.details.CaseReason ){
                this.details.CaseReason = '';
            }
        },

        btnSaveDetail() {
            if( !this.details.CaseStatus || this.details.CaseStatus === '' ){
                notify({
                    title: "錯誤",
                    message: "案件狀態不能為空",
                    type: "error"
                });  
                return;
            }
            
            // 檢查showReason如果有顯示的話, details.CaseReason不能為空
            if( this.showReason && (!this.details.CaseReason || this.details.CaseReason === '') ){
                notify({
                    title: "錯誤",
                    message: "請選擇變更原因",
                    type: "error"
                });  
                return;
            }

            // 如果選擇的是"已安排訪視", 則details.ExpectVisitDt預計訪視時間不能為空
            if( this.details.CaseStatus === '已安排訪視' && (!this.details.ExpectVisitDt || this.details.ExpectVisitDt === '') ){
                notify({
                    title: "錯誤",
                    message: "當案件狀態為已安排訪視時，預計訪視時間不能為空",
                    type: "error"});  
                return;
            }

            // 儲存動作
            console.log("儲存案件明細", this.details);
            // 檢查如果ExpectVisitDt日期有值的話, details.CaseStatus不能為空
            if( this.details.ExpectVisitDt && (!this.details.CaseStatus || this.details.CaseStatus === '') ){
                notify({
                    title: "錯誤",
                    message: "當預計訪視時間有設定時，案件狀態不能為空",
                    type: "error"
                });  
                return;
            }
            const isPm = String(this.details.vTime || '10') === '14';
            const visitStartTime = isPm ? '14:00' : '10:00';
            const visitEndTime = isPm ? '16:00' : '12:00';

            const qry = {
                "ID": this.selectedRow.ID,
                "Case_Status": this.details.CaseStatus,
                "Expect_Visit_Dt": this.details.ExpectVisitDt,
                "Expect_Visit_Start_Time": this.details.ExpectVisitDt ? visitStartTime : '',
                "Expect_Visit_End_Time": this.details.ExpectVisitDt ? visitEndTime : '',
                "Memo": this.details.Memo
            }
            console.log("更新案件明細參數",qry);

            // 呼叫 API 更新案件明細
            this.$api.apicase.case_update(qry).then(response => {
                console.log("更新案件明細回應",response);
                this.getList(); // 重新載入列表資料
                
                this.showReason = false;

                notify({
                    title: "成功",
                    message: "案件明細已更新",
                    type: "success"
                });
            }).catch(error => {
                notify({
                    title: "錯誤",
                    message: "更新案件明細失敗，請稍後再試",
                    type: "error"
                });                
            });

            if( this.details.CaseStatus == '續行申貸'  ){
                // 需要申請主管覆核
                const qry = {
                    "ID": this.selectedRow.ID,
                    "Case_Reason": this.details.CaseReason
                }
                this.$api.apicase.case_submit_approval(qry).then(response => {
                    console.log("申請主管覆核",response);
                }).catch(error => {
                    notify({
                        title: "錯誤",
                        message: "申請主管覆核失敗，請稍後再試",
                        type: "error"
                    });                
                });

            }


            if( this.showReason) {
                // 檢查如果理由是其他, this.details.CaseReasonDescription不能為空
                if( this.details.CaseReason === '其他' && (!this.details.CaseReasonDescription || this.details.CaseReasonDescription === '') ){
                    notify({
                        title: "錯誤",
                        message: "請填寫其他原因的說明",
                        type: "error"
                    });  
                    return;
                }
                //將原因記錄到案件申請覆核, 並準備申請主管覆核
                const qry = {
                    "ID": this.selectedRow.ID,
                    "Case_Reason": this.details.CaseReason,
                    "Case_Reason_Description": this.details.CaseReasonDescription,
                }
                this.$api.apicase.case_submit_approval(qry).then(response => {
                    console.log("申請主管覆核",response);
                }).catch(error => {
                    notify({
                        title: "錯誤",
                        message: "申請主管覆核失敗，請稍後再試",
                        type: "error"
                    });                
                });
            }
            this.editDetail = false;
            this.editBtnVisible = true;
            this.saveBtnVisible = false;
            // 關閉對話框
            this.dialogVisible = false;        
            
        },

        // 切換編輯狀態
        btnEditDetail() {
            this.editDetail = true;
            this.details.CaseStatus = '';// 先清空, 省得誤以為沒變更
            this.saveBtnVisible = true;
            this.editBtnVisible = false;            
        },        

        btnOpDelete(row) {
            const comname = '確定要刪除 ' + row.ComName + ' 嗎?' + '並需要主管進行覆核後，才能刪除!';
            this.$confirm(comname, '提示', {
                confirmButtonText: '刪除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    message: '刪除成功',
                    type: 'success'
                });
            }).catch(() => {
                this.$message({
                    message: '已取消刪除',
                    type: 'info'
                });
            });
        },


        async btnOpDetail(row) {           
            this.selectedRow = row;
            const qry = { "ID": row.ID };
            console.log("取得案件詳細資訊參數",qry);
            await this.$api.apicase.case_detail(qry).then(response => {                
                row = response.data;
                console.log("案件詳細資訊設定到row",row);
                const rawStartTime = row.ExpectVisitStartTime || row.Expect_Visit_Start_Time || '';
                const hour = parseInt(String(rawStartTime).split(':')[0], 10);
                this.details = {
                    ...row,
                    vTime: (!Number.isNaN(hour) && hour >= 12) ? "14" : "10"
                };
                if( row.Source === '總行派案' ){
                    this.hqFieldVisible = true;
                } else {
                    this.hqFieldVisible = false;                    
                }
                if( row.Source === '續約重訂' ){
                    this.reFieldVisible = true;
                } else {
                    this.reFieldVisible = false;                    
                }

                // 根據案件狀態決定指派按鈕文字
                if( row.CaseStatus == '待分派' ){
                    this.assignBtnTitle = "指派";
                } else {
                    this.assignBtnTitle = "改派";
                }

                console.log("案件詳細資訊設定到details",this.details);

                // 找出目錄CaseStatus對應的下一步狀態選項
                this.nextSelectList = [];
                for( let i=0; i<this.status_transion.length; i++ ){
                    const key = Object.keys(this.status_transion[i])[0];
                    if( key === row.CaseStatus ){
                        this.nextSelectList = this.status_transion[i][key];
                        break;
                    }
                }

                // 若案件狀態為 pending, approved, rejected 則不可編輯
                this.submitOrNot = (row.ApprovedStatus == "pending" || row.ApprovedStatus == "approved") ? true : false;
                console.log("是否已申請覆核, 不可編輯:", this.submitOrNot);

                // 若案件狀態為pending, 則是UC的角色的人, 才可以覆核及退回
                const roleName = window.localStorage.getItem('userRole') || '';
                if( roleName.includes('UC') && row.ApprovedStatus == "pending" ){
                    this.btnApprove = true;
                } else {
                    this.btnApprove = false;
                }
                
                // 若案件狀態為 rejected, 且是UAO的角色的人, 代表案件被退回承辦, 才可以修改案件
                if( roleName.includes('UAO') && row.ApprovedStatus == "rejected" ){
                    this.editBtnVisible = true;
                } else {
                    this.editBtnVisible = false;
                }
                console.log("是否顯示:", roleName, row.ApprovedStatus, this.btnApprove, this.editBtnVisible);

                // this.btnApprove = (row.ApprovedStatus == "pending") ? true : false;

                // UC角色, 若案件"覆核後"及"待覆核"不該再能編輯，包括改派
                if( roleName.includes('UC') && (row.ApprovedStatus == "approved" || row.ApprovedStatus == "pending" ) ){
                    this.assignBtnVisible = false;
                } else
                   if( roleName.includes("UC"))
                       this.assignBtnVisible = true;
                
                // 根据权限和案件状态设置编辑按钮
                const userHasEditPermission = this.$store.getters.userMenu
                    ?.find(item => item.Name === "案件管理")?.Action
                    ?.some(item => item.Action === "修改案件") || false;
                this.editBtnVisible = userHasEditPermission && !this.submitOrNot;

                this.dialogVisible = true;

            }).catch(error => {
                notify({
                    title: "錯誤",
                    message: "獲取案件詳細資訊失敗，請稍後再試",
                    type: "error"
                });                
            });
        }, 

        btnOpNews(row) {
            // 使用 router.resolve 來取得完整的 URL
            const route = this.$router.resolve({ name: 'bi-news-search', query: { q: row.ComName } });
            // 使用 window.open 在新視窗中開啟
            window.open(route.href, '_blank');
        },
        
        async showCaseHistory() {
            if (!this.selectedRow || !this.selectedRow.CaseNo) {
                notify({
                    title: "錯誤",
                    message: "無法取得案件編號",
                    type: "error"
                });
                return;
            }
            
            const qry = {
                "CaseID": this.selectedRow.ID,
                "Page_Size": 10,
                "Page_Num": 1
            };
            
            console.log("查詢案件歷程參數", qry);
            
            try {
                const response = await this.$api.apicase.case_history(qry);
                console.log("案件歷程資料", response);
                this.caseHistoryData = response.data || [];
                this.historyDrawerVisible = true;
            } catch (error) {
                console.error("取得案件歷程失敗", error);
                notify({
                    title: "錯誤",
                    message: "取得案件歷程失敗，請稍後再試",
                    type: "error"
                });
            }
        },  

        clickLoadProjectName() {
            // 若是UC	HE	HC1 HD,HC , 則必須帶DeptID去撈專案名稱列表
            if( roleName.includes('UC') || roleName.includes('HD') || roleName.includes('HC') || roleName.includes('HE') || roleName.includes('HC1') ){
                let qry = {
                    "isSys": true
                }
                if( this.selectedDiv && this.selectedDiv.length > 0 ){
                    qry.DeptID = this.selectedDiv[1];
                } else {
                    notify({
                        title: "錯誤",
                        message: "請先選擇區處",
                        type: "error"
                    });
                    return;
                }                
                this.$api.apicase.case_project_options(qry).then(response => {
                    console.log("專案名稱列表",response);
                    this.projectNameList = response.data || [];                
                }).catch(error => {
                    notify({
                        title: "錯誤",
                        message: "獲取專案名稱失敗，請稍後再試",
                        type: "error"
                    });                
                });                

            }


        },
        
        loadProjectNameList() {
            let qry = {
                "isSys": true
            }
            const userInfo = this.$store.getters.userInfo;
            let deptID = userInfo.DeptID;
            const roleName = this.$store.getters.userRole || '';
            if( roleName.includes('UC') ){
                qry.DeptID = deptID;
            }
            if( roleName.includes('UAO') ){
                qry.UserID = userInfo.UserID;
            }
            


            console.log("撈專案名稱列表參數", qry);
            // 由caseMater那表裡撈專案名稱列表，提供搜尋條件選擇用
            this.$api.apicase.case_project_options(qry).then(response => {
                console.log("專案名稱列表",response);
                this.projectNameList = response.data || [];                
            }).catch(error => {
                notify({
                    title: "錯誤",
                    message: "獲取專案名稱失敗，請稍後再試",
                    type: "error"
                });                
            });

        },

        // 決定指派按鈕是否顯示
        async getFunctions() {
            try {
                const funs = this.$store.getters.userInfo;
                // console.log("使用者功能列表", funs);
                if(funs && funs.Menu){
                    const actions = funs.Menu.find(item=>item.Name=="案件管理").Action || [];
                    // console.log("使用者功能列表", actions);
                    this.assignBtnVisible = actions.some(item => item.Action === "指派/改派案件");
                    this.editBtnVisible = actions.some(item => item.Action === "修改案件");
                    console.log("是否有指派功能", this.assignBtnVisible);
                    console.log("是否有編輯功能", this.editBtnVisible);
                }
                else {
                    notify({
                        title: "錯誤",
                        message: "無法取得使用者功能列表，請重新登入",
                        type: "error"
                    });
                }

                const roleName = this.$store.getters.userRole || '';
                
                // HE, HC1, HD, HC 部門可以選取btnDivVisible
                if( roleName.includes('HE') || roleName.includes('HC1') || roleName.includes('HD') || roleName.includes('HC') ){
                    this.btnDivVisible = true;
                } else {
                    this.btnDivVisible = false;
                }
                // UC 部門可以選取btnUserVisible
                if( roleName.includes('UC') ){
                    this.btnUserVisible = true;
                    this.btnApprove = true;
                } else {
                    this.btnUserVisible = false;
                    this.btnApprove = false;
                }

                // 決定DivSelect元件顯示的層級
                if( roleName=="HE" || roleName=="HC1" ){
                    const branchArea = funs.DivisionCode;
                    console.log('branchArea:', branchArea);
                    this.filterDivisionCode = branchArea;
                }                
                


            } catch (error) {
                console.error("獲取使用者功能列表失敗", error);
                notify({
                    title: "錯誤",
                    message: "獲取使用者功能列表失敗，請稍後再試",
                    type: "error"
                });                
            }
        },

    },

    async mounted() {
        // 延後載入分行承辦人清單（非必要的初始資料）
        setTimeout(() => {
            this.getBranchStaff();
        }, 1000); // 延後1秒載入
        await this.getFunctions();
         
        // 並行執行關鍵 API 調用以加快初始載入速度
        await Promise.all([            
            this.getList(),
            this.loadProjectNameList()
        ]);
        

        if( this.btnDivVisible){
            // 若有, 則載入 this.caseStaffList, 並從中整理出區處清單
        }




        // 檢查是否有從其他頁面傳來的 caseId 參數
        if (this.$route.query.caseId) {
            const caseId = this.$route.query.caseId;
            console.log("收到從行事曆傳來的案件 ID:", caseId);
            
            // 根據 caseId 載入案件詳細資料並打開 dialog
            try {
                const qry = { "ID": caseId };
                console.log("準備查詢案件詳細資訊，參數:", qry);
                
                const response = await this.$api.apicase.case_detail(qry);
                console.log("API 返回的完整 response:", response);
                console.log("response.data:", response.data);
                
                // 檢查 response 的結構
                const row = response.data || response;
                console.log("案件詳細資訊 row:", row);
                
                if (!row || !row.CaseNo) {
                    throw new Error("API 返回的數據格式不正確或數據為空");
                }
                
                this.selectedRow = row;
                this.details = row;


                // 找出目錄CaseStatus對應的下一步狀態選項
                this.nextSelectList = [];
                for( let i=0; i<this.status_transion.length; i++ ){
                    const key = Object.keys(this.status_transion[i])[0];
                    if( key === row.CaseStatus ){
                        this.nextSelectList = this.status_transion[i][key];
                        break;
                    }
                }

                // 判斷是否已申請覆核
                this.submitOrNot = (row.ApprovedStatus == "pending" || row.ApprovedStatus == "approved" || row.ApprovedStatus == "rejected") ? true : false;
                
                // 打開對話框
                this.dialogVisible = true;
                
                // 清除 URL 中的 query 參數，避免重複觸發
                this.$router.replace({ query: {} });
                
            } catch (error) {
                console.error("獲取案件詳細資訊失敗", error);
                notify({
                    title: "錯誤",
                    message: "獲取案件詳細資訊失敗，請稍後再試",
                    type: "error"
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#caseMgmtBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;

    .searchWrap   {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;

            .itemWrap {
                span {
                    margin-right: 10px;
                }                
                display: flex;
                flex-direction: row;
                align-items: center;                
                margin-top:5px; 
                margin-bottom: 5px;
                margin-right: 10px;                
                &.col-2 {
                    flex: 0 0 50%;
                }
                &.export-right {
                    margin-left: auto;
                    margin-right: 0;
                }
            }
        }    
    
  }
    .content {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    margin-top: 20px;
    padding: 0px 5%;
    .legend {
        display: flex;
        flex-direction: row;
        .legendItem {
            width: 80px;
            margin: 5px 10px;
        }
        
    }

  }  
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   } 

    ::v-deep .el-table .export-selection-column .cell {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 0;
        white-space: nowrap;
    }

    ::v-deep .el-table .export-selection-column .cell::before {
        content: '匯出';
        font-size: 13px;
        line-height: 1;
        color: #606266;
    }
}

    .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
   }

/* 保留原有的樣式 */

/* 添加對話框樣式 */
.dialogBox {
  .details-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 3px 3px;
    padding: 5px 10px;
  }

  .detail-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    // padding: 8px 10px;
    border-bottom: 1px solid #ebeef5;
    
    
    .detail-label {
        display: flex;
        align-items: center;
      min-width: 150px;
      max-width: 150px;
      font-weight: bold;
      color: #303133;
      text-align: right;
      padding-right: 12px;
      font-size: 14px;      
      flex-shrink: 0;
    }
        /* 讓 detail-row 橫跨兩欄 */
        &.col-span-2 {
            grid-column: 1 / -1;
            .detail-content {
                width: 100%;
            }
        }
    
    .detail-content {
        display: flex;
        align-items: center;
      flex: 1;
      color: #606266;
      font-size: 14px;      
      word-break: break-word;
    }
  }

    .row1 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            margin: 10px 10px;
            width: 50%;

            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: center;
            }
        }
    }  
  
  h3 {
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 16px;
    color: #303133;
    font-weight: 500;
  }
}
</style>